import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  type UpdateVoucherAutoAssignmentRulePayload,
  type UpdateVoucherAutoAssignmentRuleResponse,
  updateVoucherAutoAssignmentRule,
} from '~/services/PromoService';

import { voucherAutoAssignmentRuleQueryKeys } from './voucherAutoAssignmentRuleQueryKeys';

type Vars = {
  voucherAutoAssignmentRuleId: string;
  payload: UpdateVoucherAutoAssignmentRulePayload;
};

export function useUpdateVoucherAutoAssignmentRule() {
  const queryClient = useQueryClient();
  return useMutation<UpdateVoucherAutoAssignmentRuleResponse, Error, Vars>({
    mutationFn: ({ voucherAutoAssignmentRuleId, payload }) =>
      updateVoucherAutoAssignmentRule(voucherAutoAssignmentRuleId, payload),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: voucherAutoAssignmentRuleQueryKeys.all });
      queryClient.invalidateQueries({
        queryKey: voucherAutoAssignmentRuleQueryKeys.detail(vars.voucherAutoAssignmentRuleId),
      });
    },
  });
}
